import { render, staticRenderFns } from "./medicalReport.vue?vue&type=template&id=4a43da04&scoped=true&"
import script from "./medicalReport.vue?vue&type=script&lang=ts&"
export * from "./medicalReport.vue?vue&type=script&lang=ts&"
import style0 from "./medicalReport.vue?vue&type=style&index=0&id=4a43da04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43da04",
  null
  
)

export default component.exports